import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23753750")

_pushScopeId("data-v-23753750")
const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "account-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_account = _resolveComponent("account")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode("ul", null, [
      _createVNode("li", _hoisted_2, [
        _createVNode(_component_account)
      ])
    ])
  ]))
})